/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgContactTargetOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m21.293 22.707-1.536-1.535a5 5 0 0 1-6.929-6.929L1.293 2.707l1.414-1.414 14.21 14.21a1.5 1.5 0 0 1 1.581 1.581l4.21 4.209-1.415 1.414zm-5.79-5.79-1.21-1.21a3 3 0 0 0 4.001 4.001l-1.21-1.21a1.5 1.5 0 0 1-1.581-1.581zm-2.941-8.355L14 10a5 5 0 0 0-7-7l1.438 1.438a3 3 0 0 1 4.124 4.124zM17 12c-.313 0-.62.029-.916.084l2.207 2.207c.62.296 1.122.798 1.418 1.418l2.207 2.207A5 5 0 0 0 17 12z"
        fill="currentcolor"
      />
      <path
        d="M4 21c0-1.459.436-2.672 1.32-3.524C6.204 16.622 7.673 16 10 16v-2c-2.674 0-4.704.72-6.07 2.037C2.565 17.356 2 19.143 2 21v1h2v-1z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgContactTargetOff as ContactTargetOff };
